import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_public/legal/privacy')({
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <article className="max-w-3xl mx-auto px-6 py-16 prose prose-slate">
      <h1 className="text-3xl font-semibold text-ink">Política de Privacidad</h1>
      <p className="text-quiet">Última actualización: 24 de abril de 2026</p>

      <h2 className="text-xl font-semibold text-ink mt-10">1. Datos que recopilamos</h2>
      <p className="text-body">
        Email, nombre, contenido de proyectos y tareas. Metadata técnica (IP, navegador) para
        seguridad y analítica anónima.
      </p>

      <h2 className="text-xl font-semibold text-ink mt-8">2. Uso</h2>
      <p className="text-body">
        Operar el servicio, mejorar la plataforma, comunicaciones transaccionales. No vendemos datos
        a terceros.
      </p>

      <h2 className="text-xl font-semibold text-ink mt-8">3. Retención</h2>
      <p className="text-body">
        Datos activos mientras la cuenta exista. Al eliminar, purga en 90 días. Copias de seguridad
        cifradas hasta 180 días.
      </p>

      <h2 className="text-xl font-semibold text-ink mt-8">4. Derechos</h2>
      <p className="text-body">
        Acceso, rectificación, eliminación y portabilidad. Contáctanos en{' '}
        <a href="mailto:privacy@meidei.com" className="text-accent underline">
          privacy@meidei.com
        </a>
        .
      </p>

      <h2 className="text-xl font-semibold text-ink mt-8">5. Subprocesadores</h2>
      <p className="text-body">
        Supabase (infraestructura), Cloudflare (CDN), Resend (email transaccional), Sentry
        (observabilidad). Todos con DPA firmado.
      </p>
    </article>
  );
}
